// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BackgroundPanelVideo__container-b8e077 {
  width: 100%;
  height: 200px;
}

.BackgroundPanelVideo__container-b8e077 > div {
  background-color: transparent !important;
}

.BackgroundPanelVideo__container-b8e077 video {
  width: 100%;
  height: 100%;
  border-radius: var(--indent-8px);
  transform: scale(-1, 1);
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/Shared/AnimatedBackgroundPanel/components/BackgroundPanelVideo/BackgroundPanelVideo.styles.m.css"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;AACF;;AAEA;EACE,wCAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,gCAAA;EACA,uBAAA;AACF","sourcesContent":[".container {\n  width: 100%;\n  height: 200px;\n}\n\n.container > div {\n  background-color: transparent !important;\n}\n\n.container video {\n  width: 100%;\n  height: 100%;\n  border-radius: var(--indent-8px);\n  transform: scale(-1, 1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `BackgroundPanelVideo__container-b8e077`
};
module.exports = ___CSS_LOADER_EXPORT___;
